import TableCells from 'components/TableCells';
import { Column, CellProps } from 'react-table';
import { PodcastDetails } from './types';

const columns: ReadonlyArray<Column<PodcastDetails>> = [
  {
    Header: 'Podcast',
    id: 'podcast',
    Cell: ({ row }: CellProps<PodcastDetails>) => (
      <TableCells.PodcastInfoCell
        url={row.original.thumbnailUrl}
        title={row.original.title}
        episodeCount={row.original.totalEpisodes}
      />
    ),
    disableSortBy: true,
    width: 800,
  },
];

export default columns;
